// extracted by mini-css-extract-plugin
export default {"head":"v7_dT6","body":"BJRcry","hero":"XcvQqv","video-wrapper":"PqhZ2g","videoWrapper":"PqhZ2g"};